import { API_BASE_URL } from '../common/ApiClient';
import { ProcessingEventUrl } from '../processingEvent/query/ProcessingEventUrl';
import { OutputDataUrl } from './query/OutputDataUrl';

export * from './schema/types';
export * from './schema/OutputDataSchema';
export * from './schema/OutputDataObjectGroupProcessingStateSchema';
export * from './query/useOutputDataGroupProcessingStateQuery';
export * from './query/useCalculateOutputData';
export * from './query/useCancelErrorsOutputData';
export * from './query/useValidateOutputData';
export * from './query/useConfirmOutputData';
export * from './query/useDeleteOutputData';
export * from './query/useOutputDescriptionProcessingStatesQuery';
export * from './query/useOutputDataGroupProcessingStateRefreshQuery';
export * from './query/useOutputDataProcessingEventsQuery';
export * from './query/useOutputDataConfirmationsQuery';
export * from './query/useMutateOutputDataConfirmations';
export * from './query/useMutateTestCalculateDagQuery';
export * from './query/useTestCalculateQuery';
export * from './query/useTestCalculateOutputDataQuery';
export * from './query/useMutateTestValidateDagQuery';
export * from './query/useTestValidateQuery';
export * from './query/useTimeSeriesCalculateOutputData';
export * from './query/useTimeSeriesValidateOutputData';
export * from './query/useConfirmTimeSeriesOutputData';

export const OutputProcessingErrorExcelUrl =
  API_BASE_URL + ProcessingEventUrl.OUTPUT_PROCESSING_EVENT_ERROR_EXCEL;

export const TestCalculationExcelUrl =
  API_BASE_URL + OutputDataUrl.TEST_CALCULATIONS_EXCEL;

export enum OutputProcessingEventReportType {
  processingEvent = 'processingEvent',
  processingGroup = 'processingGroup',
}
